module.exports = __webpack_public_path__ + "static/media/eating.5796d3b5.png";